var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable8401111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_783_8851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8156 17.5942H1.51255C1.04418 17.5942 0.664062 17.214 0.664062 16.7457V10.9234C0.664062 10.455 1.04418 10.0749 1.51255 10.0749H55.8156C56.2839 10.0749 56.6641 10.455 56.6641 10.9234V16.7474C56.6641 17.2157 56.2839 17.5942 55.8156 17.5942ZM2.36103 15.8972H54.9671V11.7719H2.36103V15.8972Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98768 45.9251H3.49653C3.24707 45.9251 3.0078 45.8148 2.84659 45.6213C2.68538 45.4279 2.6175 45.175 2.66162 44.929L7.64392 16.5981C7.7152 16.1942 8.06647 15.8972 8.47883 15.8972H14.2927C14.5591 15.8972 14.8119 16.0228 14.9714 16.2366C15.131 16.4504 15.1819 16.727 15.1055 16.9833L6.80053 45.3159C6.69532 45.6773 6.36271 45.9251 5.98768 45.9251ZM4.50792 44.2281H5.35301L13.1608 17.5942H9.19156L4.50792 44.2281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3721 45.925H49.8793C49.5025 45.925 49.1716 45.6773 49.0664 45.3158L40.7614 16.9849C40.6851 16.7287 40.736 16.4521 40.8955 16.2383C41.0567 16.0244 41.3079 15.8989 41.5743 15.8989H47.3881C47.8005 15.8989 48.1517 16.1958 48.223 16.5997L53.207 44.9306C53.2494 45.1784 53.1816 45.4312 53.0221 45.623C52.8625 45.8147 52.6216 45.925 52.3721 45.925ZM50.5139 44.2281H51.3607L46.6754 17.5941H42.7079L50.5139 44.2281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2064 23.1568H12.661C12.1926 23.1568 11.8125 22.7767 11.8125 22.3083C11.8125 21.84 12.1926 21.4598 12.661 21.4598H43.2064C43.6748 21.4598 44.0549 21.84 44.0549 22.3083C44.0549 22.7767 43.6765 23.1568 43.2064 23.1568Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_783_8851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.664062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable8401111);
export default __webpack_public_path__ + "static/media/table_84011 (1) 1.d5c85ef002f4549629fd824b3f28db0e.svg";
export { ForwardRef as ReactComponent };